import { Pipe, PipeTransform } from '@angular/core';

export type DateDisplayFormat = 'short' | 'medium' | 'long' | 'full' | 'monthDay' | 'monthYear';

@Pipe({
  name: 'localDate',
  standalone: true,
})
export class LocalDatePipe implements PipeTransform {
  transform(value: string | null | undefined, format: DateDisplayFormat = 'medium'): string {
    if (!value) return '';

    // Match YYYY-MM-DD
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value.trim());
    if (!match) {
      return value;
    }

    const year = parseInt(match[1], 10);
    const monthIndex = parseInt(match[2], 10) - 1; // 0-indexed month
    const day = parseInt(match[3], 10);

    // Create date explicitly in the local user's timezone at noon to prevent daylight savings shifts
    const localDate = new Date(year, monthIndex, day, 12, 0, 0);

    let options: Intl.DateTimeFormatOptions;

    switch (format) {
      case 'short':
        // e.g. US: "9/4/26", UK: "04/09/2026", Germany: "4.9.26"
        options = { dateStyle: 'short' };
        break;

      case 'medium':
        // e.g. US: "Sep 4, 2026", UK: "4 Sept 2026", Germany: "04.09.2026"
        options = { dateStyle: 'medium' };
        break;

      case 'long':
        // e.g. US: "September 4, 2026"
        options = { dateStyle: 'long' };
        break;

      case 'full':
        // e.g. US: "Friday, September 4, 2026"
        options = { dateStyle: 'full' };
        break;

      case 'monthDay':
        // e.g. US: "Sep 4", UK: "4 Sept"
        options = { month: 'short', day: 'numeric' };
        break;

      case 'monthYear':
        // e.g. "September 2026"
        options = { month: 'long', year: 'numeric' };
        break;

      default:
        options = { dateStyle: 'medium' };
        break;
    }

    // Undefined locale tells Intl to inspect the user browser's active locale
    return new Intl.DateTimeFormat(undefined, options).format(localDate);
  }
}
